import * as SeparatorPrimitive from '@radix-ui/react-separator'
import PropTypes from 'prop-types'

// Utils
import { cn } from '@/utils/helpers'

function Separator({ className = '', orientation = 'horizontal', decorative = true, ...props }) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  )
}

Separator.propTypes = {
  className: PropTypes.string,
  orientation: PropTypes.string,
  decorative: PropTypes.bool,
}

export { Separator }
